/**
 * THE FULL TERMS, AS A FILE.
 *
 * The owner: "it can include some file or details, because it might have much
 * more details and part of the policies of the product." A warranty panel holds
 * a paragraph; a manufacturer's actual terms are pages, and a shopper who wants
 * them wants the document.
 *
 * ── WHAT DECIDES WHETHER THIS RENDERS ───────────────────────────────────────
 *
 * Nothing here does. The server publishes `warrantyLibrary` / `returnPolicyLibrary`
 * ONLY as the named entry that WON the resolution for a product the shop is
 * actually selling — there is no public route that lists a shop's policies at
 * all — so the file is under exactly the same visibility rule as the promise it
 * belongs to. A retired entry, an entry attached to something this product does
 * not inherit from, and every entry belonging to another shop have no door to
 * come out of. This component's only job is to draw the link that arrived.
 *
 * ── AND IT IS ALWAYS THE SHOP'S FILE, NEVER OURS ────────────────────────────
 *
 * It is absent on the platform default, because Stylon has no terms document to
 * hand out on a merchant's behalf. The link opens in a new tab with
 * `rel="noreferrer"`: it is a merchant-uploaded document, and the page it opens
 * is not one this app controls.
 */
import React from 'react';
import { FiFileText } from 'react-icons/fi';
import styles from './styles.module.css';

const PolicyDocumentLink = ({ entry, t, testId }) => {
  const url = entry && entry.documentUrl;
  if (!url) return null;
  return (
    <a
      className={styles.policyDocLink}
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid={testId}
    >
      <FiFileText aria-hidden="true" />
      <span>
        {entry.documentName
          || t('productDetail.policyDocument', { defaultValue: 'Read the full terms' })}
      </span>
    </a>
  );
};

export default PolicyDocumentLink;
